
import _ from 'underscore';
import { CONFIRM_MESSAGES_TYPE } from './constants';

const CONVERSION_SCOPE = {
  ACCOUNT_SCOPE: 'account-scope',
  CAMPAIGN_SCOPE: 'campaign-scope',
};

const targetBiddingSchemeTypeList = [
  'MaxConversions',
  'TargetCpa',
  'TargetRoas',
  'MaxConversionValue',
];

export const getMessageType = (initialData, patchData) => {
  const BiddingSchemeType = _.get(patchData, ['campaign', 'BiddingScheme', 'Type']);
  if (!targetBiddingSchemeTypeList.includes(BiddingSchemeType)) {
    return null;
  }

  const goalSelectionPath = ['campaign', 'conversionGoals', 'goalSelection'];
  const initialGoalSelection = _.get(patchData, ['campaign', 'conversionGoals', 'originalConversionGoals'], []);
  const goalSelection = _.get(patchData, goalSelectionPath, []);
  const hasAnyGoalSelections = _.size(goalSelection) > 0;

  const initialGoalScope = _.size(initialGoalSelection) > 0 ? CONVERSION_SCOPE.CAMPAIGN_SCOPE : CONVERSION_SCOPE.ACCOUNT_SCOPE;
  const newGoalScope = hasAnyGoalSelections? CONVERSION_SCOPE.CAMPAIGN_SCOPE : CONVERSION_SCOPE.ACCOUNT_SCOPE;
  const scopeSelectionPath = ['campaign', 'conversionGoals', 'goalScopeSelection'];
  const newGoalScopeValue = _.get(patchData, scopeSelectionPath, '');

  const removedGoals = initialGoalSelection.filter(initialGoal =>
    !goalSelection.some(goal => goal.Id === initialGoal.Id));

  if (initialGoalScope === CONVERSION_SCOPE.ACCOUNT_SCOPE && (newGoalScope === CONVERSION_SCOPE.CAMPAIGN_SCOPE && newGoalScopeValue === CONVERSION_SCOPE.CAMPAIGN_SCOPE)) {
    return CONFIRM_MESSAGES_TYPE.CONFIRM_CAMPAIGN_LEVEL_GOALS;
  } else if ((newGoalScope === CONVERSION_SCOPE.ACCOUNT_SCOPE && initialGoalScope === CONVERSION_SCOPE.CAMPAIGN_SCOPE) || (newGoalScopeValue === CONVERSION_SCOPE.ACCOUNT_SCOPE && initialGoalScope === CONVERSION_SCOPE.CAMPAIGN_SCOPE)) {
    return CONFIRM_MESSAGES_TYPE.CONFIRM_ACCOUNT_LEVEL_GOALS;
  }

  if (removedGoals.some(goal => goal && (goal.TrackingStatus === 'RecordingConversions') && hasAnyGoalSelections)) {
    return CONFIRM_MESSAGES_TYPE.REMOVE_ACTIVE_CONVERSION;
  }

  return null;
};

export const getNeedConfirming = (permissions, context) => {
  const data = context.data || {};
  const initialData = context.initialData || {};

  if (!(
    _.get(permissions, ['dynamic', 'ConversionAssociationWarning'], false)
    || _.get(permissions, ['dynamic', 'ConversionAssociationWarningP2'], false)
    || _.get(permissions, ['dynamic', 'ConversionAssociationWarningP3'], false)
  )) {
    return false;
  }

  return getMessageType(initialData, data) !== null;
};
